import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";

const LayoutGroupPresentationPropsDefault: ComponentThemeProps["layoutGroup"]["defaultProps"] = {};

export default LayoutGroupPresentationPropsDefault;
